export default __webpack_public_path__ + "static/media/stethoscope.5252a6b4.svg";